import { gql, TypedDocumentNode } from '@apollo/client';
import {
  LogPaymentTransactionResponse,
  PaymentTerminalsResponse,
  SetPaymentTerminalTransactionToPaymentResponse,
  UpdatePaymentTerminalTransactionOnPaymentResponse,
  RemoveTransactionFromPaymentResponse,
  RevertTransactionFromPaymentResponse,
} from './types';

export interface LogTransactionVariables {
  input: { response: Record<string, unknown> }
}

export interface SetTransactionVariables {
  input: Record<string, unknown>
}

export interface UpdateTransactionVariables {
  input: Record<string, unknown>
}

export interface RemoveTransactionVariables {
  input: { towingRecordId: number; transactionId: number }
}

export interface RevertTransactionVariables {
  input: Record<string, unknown>
}

export const LOG_TRANSACTION: TypedDocumentNode<LogPaymentTransactionResponse, LogTransactionVariables> = gql`
  mutation LogPaymentTransaction($input: LogPaymentTerminalInput!) {
    logPaymentTerminalRequest(input: $input) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on LogPaymentTransactionSuccess {
        success
      }
    }
  }
`;

export const GET_PAYMENT_TERMINALS: TypedDocumentNode<PaymentTerminalsResponse, Record<string, never>> = gql`
  query GetPaymentTerminals {
    activePaymentTerminals {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on PaymentTerminalsSuccess {
        paymentTerminals {
          terminalName
          terminalId
          userName
          password
          url
          isDefault
        }
        success
      }
    }
  }
`;

export const SET_TRANSACTION_TO_PAYMENT: TypedDocumentNode<SetPaymentTerminalTransactionToPaymentResponse, SetTransactionVariables> = gql`
  mutation SetTransactionToPayment($input: setTransactionToPaymentInput!) {
    setTransactionToPaymentRequest(input: $input) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on SetTransactionToPaymentSuccess {
        paymentTerminalTransaction {
          id
          receiptId
          previousTransaction
          transactionStatus
          transactionType
          transactionId
          transactionUniqueId
          authorizationCode
          amount
          referenceNumber
          transactionTime
          panMaskedForCustomer
          panMaskedForClerk
          cardReadingMethod
          terminalId
          terminalName
          merchantReceipt
          customerReceipt
          created
          updated
          deletedAt
        }
        success
      }
    }
  }
`;

export const UPDATE_TRANSACTION_ON_PAYMENT: TypedDocumentNode<UpdatePaymentTerminalTransactionOnPaymentResponse, UpdateTransactionVariables> = gql`
  mutation UpdateTransactionOnPayment($input: updateTransactionOnPaymentInput!) {
    updateTransactionOnPaymentRequest(input: $input) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on UpdateTransactionOnPaymentSuccess {
        paymentTerminalTransaction {
          id
          receiptId
          previousTransaction
          transactionStatus
          transactionType
          transactionId
          transactionUniqueId
          authorizationCode
          amount
          referenceNumber
          transactionTime
          panMaskedForCustomer
          panMaskedForClerk
          cardReadingMethod
          terminalId
          terminalName
          merchantReceipt
          customerReceipt
          created
          updated
          deletedAt
        }
        success
      }
    }
  }
`;

export const REMOVE_TRANSACTION_FROM_PAYMENT: TypedDocumentNode<RemoveTransactionFromPaymentResponse, RemoveTransactionVariables> = gql`
  mutation RemoveTransactionFromPayment($input: RemoveTransactionFromPaymentInput!) {
    removeTransactionFromPaymentRequest(input: $input) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on RemoveTransactionFromPaymentSuccess {
        success
      }
    }
  }
`;

export const REVERT_TRANSACTION_FROM_PAYMENT: TypedDocumentNode<RevertTransactionFromPaymentResponse, RevertTransactionVariables> = gql`
  mutation RevertTransactionFromPayment($input: RevertTransactionFromPaymentInput!) {
    revertTransactionFromPaymentRequest(input: $input) {
      __typename
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
      ... on RevertTransactionFromPaymentSuccess {
        paymentTerminalTransaction {
          id
          receiptId
          previousTransaction
          transactionStatus
          transactionType
          transactionId
          transactionUniqueId
          authorizationCode
          amount
          referenceNumber
          transactionTime
          panMaskedForCustomer
          panMaskedForClerk
          cardReadingMethod
          terminalId
          terminalName
          merchantReceipt
          customerReceipt
          created
          updated
          deletedAt
        }
        success
      }
    }
  }
`;
